import React from 'react';

import {
  Page,
  Text,
  View,
  Font,
  Document,
  StyleSheet,
} from '@react-pdf/renderer';

import { colors } from '../../lib/colors';
import { getFullDateTimeStamp } from '../../lib/time';
import { registerPdfFonts } from '../../lib/registerPdfFonts';

import Header from '../ProgramActivitySlideover/ProgramAssessmentPDF/components/Header';
import PdfFormattedText from '../Library/LibraryFormPDF/components/PdfFormattedText';

registerPdfFonts(Font);

export type ProgramNotePdfFields = {
  title?: string | null;
  note?: string | null;
  createdAt?: string | null;
  createdByProviderUser?: {
    name?: string | null;
  } | null;
};

const ProgramNotePDF: React.FC<{
  programNote: ProgramNotePdfFields;
  patientName?: string;
  wordmarkLogoUrl?: string | null;
  participantId?: string | null;
}> = ({ programNote, patientName, wordmarkLogoUrl, participantId }) => {
  const createdAtDateFormatted = programNote?.createdAt
    ? getFullDateTimeStamp(programNote.createdAt)
    : '';
  const createdByName = programNote?.createdByProviderUser?.name || 'Unknown';

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View>
          <Header
            patientName={patientName}
            completedAtDateFormatted={createdAtDateFormatted}
            wordmarkLogoUrl={wordmarkLogoUrl}
            participantId={participantId}
          />

          <Text style={styles.title}>{programNote?.title}</Text>

          <View style={styles.createdBySection}>
            <Text style={styles.createdByLabel}>Created by:</Text>
            <Text style={styles.createdByName}>{createdByName}</Text>
          </View>

          <View style={styles.noteSection}>
            <PdfFormattedText style={styles.noteText}>
              {programNote?.note}
            </PdfFormattedText>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ProgramNotePDF;

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontFamily: 'sans',
    backgroundColor: 'white',
  },
  title: {
    fontSize: 16,
    color: colors.neutral[150],
    fontFamily: 'serif',
    fontWeight: 500,
    marginBottom: 12,
  },
  createdBySection: {
    flexDirection: 'row',
    marginBottom: 16,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: colors.neutral[50],
  },
  createdByLabel: {
    fontSize: 10,
    color: colors.neutral[100],
    fontWeight: 400,
    marginRight: 6,
  },
  createdByName: {
    fontSize: 10,
    color: colors.neutral[125],
    fontWeight: 500,
  },
  noteSection: {
    marginTop: 8,
  },
  noteText: {
    fontSize: 11,
    lineHeight: 1.6,
    color: colors.neutral[125],
    fontFamily: 'sans',
    fontWeight: 400,
  },
});
